module.exports = __webpack_public_path__ + "img/ron_n.189cbba1.png";